module.exports = ".dashEmp {\r\n    padding: 15px;\r\n}"